// extracted by mini-css-extract-plugin
export default {"main":"AlbumLists_main__GEqis","lists":"AlbumLists_lists__cg0Wj","icon":"AlbumLists_icon__9QkPG","delete":"AlbumLists_delete__6NKcF"};